import { useEffect } from 'react'

import { NOTIFICATION_TYPE } from '../../../../../../constants/common'
import { HTML_LINK_TARGET } from '../../../../../../constants/html'
import i18n from '../../../../../../i18n'
import { useFormValidationErrorsNotification } from '../../../../../Form'
import {
  CREATE_PASSWORD_FORM_FIELD_NAME_ACCEPT_RULES,
  CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD,
  CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_EQUAL,
  CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_MATCH_REQUIREMENTS,
  CREATE_PASSWORD_FORM_VALIDATION_ERROR_RULES_ARE_NOT_ACCEPTED,
} from '../../CreatePasswordForm.constants'
import {
  isCreatePasswordFormValidationErrorPasswordIsNotEqual,
  isCreatePasswordFormValidationErrorPasswordIsNotMatchRequirements,
  isCreatePasswordFormValidationErrorRulesAreNotAccepted,
} from '../../CreatePasswordForm.utils'

export function useValidationErrorsNotification({
  errors,
  onRemoveNotification,
  onSetNotification,
}) {
  useFormValidationErrorsNotification({
    errors,
    onRemoveNotification,
    onSetNotification,
  })

  useEffect(() => {
    if (
      isCreatePasswordFormValidationErrorPasswordIsNotEqual(
        errors[CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD]
      )
    ) {
      onSetNotification({
        id: CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_EQUAL,
        text: i18n.t('Error.NotificationCreatePasswordNotEqualKey'),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      onRemoveNotification(
        CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_EQUAL
      )
    }

    if (
      isCreatePasswordFormValidationErrorPasswordIsNotMatchRequirements(
        errors[CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD]
      )
    ) {
      onSetNotification({
        id: CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_MATCH_REQUIREMENTS,
        linkProps: {
          reloadDocument: true,
          target: HTML_LINK_TARGET.blank,
          title: i18n.t(
            'Error.NotificationCreatePasswordRequirementNotPassedRulesHelpCenterLinkTextKey'
          ),
          to: `https://idwell.crunch.help/`,
        },
        text: i18n.t('Error.NotificationCreatePasswordRequirementNotPassedKey'),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      onRemoveNotification(
        CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_MATCH_REQUIREMENTS
      )
    }

    if (
      isCreatePasswordFormValidationErrorRulesAreNotAccepted(
        errors[CREATE_PASSWORD_FORM_FIELD_NAME_ACCEPT_RULES]
      )
    ) {
      onSetNotification({
        id: CREATE_PASSWORD_FORM_VALIDATION_ERROR_RULES_ARE_NOT_ACCEPTED,
        text: i18n.t('Error.NotificationCreatePasswordRulesAreNotAcceptedKey'),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      onRemoveNotification(
        CREATE_PASSWORD_FORM_VALIDATION_ERROR_RULES_ARE_NOT_ACCEPTED
      )
    }
  }, [errors])
}
